App.controller('HealthInsuranceInfoStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$timeout', function ($scope, $sce, $state, $http, packageService, $timeout) {
    $scope.page = 'healthInsuranceInfo_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Opieka medyczna';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $timeout(function () {
        if (!$('.menu.menu_3b').hasClass('open')) {
            $('a[target=".menu_3b"]').trigger('click');
        }
    }, 0);

    packageService.dataPackageLists().then(function (data) {
        $scope.package = data.data.group;
    });

    packageService.showEndOfAccessionPopup();
}]);
